export default [
    {
        path: "grouping",
        name:  "GROUPING",
        meta: {
            title: "权益分组管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/SKU/grouping.vue"),
    },
    {
        path: "Equity",
        name:  "EQUITY",
        meta: {
            title: "权益项管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/SKU/Equity.vue"),
    },
    {
        path: "SchemeGrouping",
        name:  "SCHEME_GROUPING",
        meta: {
            title: "方案分组管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/SKU/SchemeGrouping.vue"),
    },
    {
        path: "programme",
        name:  "PROGRAMME",
        meta: {
            title: "方案项管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/SKU/programme.vue"),
    },
];
